(function () {
  'use strict';

  function selectFilter(center, filter) {
    var cards = Array.prototype.slice.call(center.querySelectorAll('[data-urt1-card]'));
    var buttons = Array.prototype.slice.call(center.querySelectorAll('[data-urt1-filter]'));
    var shown = 0;
    cards.forEach(function (card) {
      var tags = (card.getAttribute('data-urt1-tags') || '').split(/\s+/);
      var visible = filter === 'all' || tags.indexOf(filter) !== -1;
      card.hidden = !visible;
      if (visible) shown += 1;
    });
    buttons.forEach(function (button) {
      var active = button.getAttribute('data-urt1-filter') === filter;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    var status = center.querySelector('[data-urt1-status]');
    if (status) status.textContent = filter === 'all' ? 'Showing all 10 documented application paths.' : 'Showing ' + shown + ' matching documented application path' + (shown === 1 ? '.' : 's.');
  }

  function openCenter(center, application, shouldScroll) {
    center.hidden = false;
    selectFilter(center, 'all');
    center.querySelectorAll('.is-highlighted').forEach(function (card) { card.classList.remove('is-highlighted'); });
    if (application) {
      var card = center.querySelector('[data-application="' + CSS.escape(application) + '"]');
      if (card) {
        card.classList.add('is-highlighted');
        window.setTimeout(function () { card.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 80);
        return;
      }
    }
    if (shouldScroll) center.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function initialize() {
    var centers = Array.prototype.slice.call(document.querySelectorAll('[data-urt1-center]'));
    centers.forEach(function (center) {
      center.querySelectorAll('[data-urt1-filter]').forEach(function (button) {
        button.addEventListener('click', function () { selectFilter(center, button.getAttribute('data-urt1-filter') || 'all'); });
      });
      var close = center.querySelector('[data-urt1-close]');
      if (close) close.addEventListener('click', function () { center.hidden = true; });
      if (!center.hidden) selectFilter(center, 'all');
    });

    document.querySelectorAll('[data-urt1-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        var center = document.querySelector('[data-urt1-context="ckb"]');
        if (center) openCenter(center, '', true);
      });
    });

    var params = new URLSearchParams(window.location.search);
    if (params.get('tool') === 'urt1-applications') {
      var ckbCenter = document.querySelector('[data-urt1-context="ckb"]');
      if (ckbCenter) openCenter(ckbCenter, params.get('application') || '', true);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
}());
